module.exports = __webpack_public_path__ + "img/eu.3befbc8e.svg";